import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["children", "borderOnGatsbyImage", "sx"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from 'react';
import { Box, useTheme } from '@chakra-ui/react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const FramedImage = _ref => {
  let {
      children,
      borderOnGatsbyImage,
      sx
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  const color = theme.colorMode === 'light' ? 'rgba(0,0,0,0.7)' : 'rgba(255,255,255,0.7)';
  if (borderOnGatsbyImage) {
    return ___EmotionJSX(Box, _extends({
      sx: _objectSpread({
        '.gatsby-image-wrapper': {
          border: `5px solid ${color}`
        }
      }, sx)
    }, props), children);
  } else {
    return ___EmotionJSX(Box, _extends({
      border: `5px solid ${color}`
    }, sx, props), children);
  }
};
export default FramedImage;